/**
 * @file wenxin 首页
 * @author wanzhongyun
 */
 import 'react-app-polyfill/ie9';
 import 'react-app-polyfill/stable';
 import 'location-origin';
 import ReactDOM from 'react-dom';
 import moment from 'moment';
 import 'moment/locale/zh-cn';
 
 import Wenxin from './Wenxin';
 
 
 
 moment.locale('zh-cn');
 
 ReactDOM.render(<Wenxin />, document.getElementById('root'));
 
 
 